import React, { useState, useEffect } from "react";
import { Accordion } from "react-bootstrap";
import { FAQContent } from "./FAQContent";
import { useScreenSize, useCustomScreen } from "../Utils";
import { use } from "react";
import { Link } from "react-router-dom";

export default function FAQSection() {
  const {
    isSmallScreen,
    isMediumScreen,
    isLargeScreen,
    isXlScreen,
    isXxlScreen,
    is4kScreen,
  } = useScreenSize();
  const { isIpadProPortrait } = useCustomScreen();
  return (
    <section
      id="faq"
      style={{
        overflowY: "scroll",
        height: isSmallScreen
          ? "auto"
          : is4kScreen
          ? "100vh"
          : isLargeScreen
          ? "100vh"
          : "100vh",
        marginTop: is4kScreen
          ? "5rem"
          : isIpadProPortrait
          ? "5rem"
          : isLargeScreen
          ? ""
          : isMediumScreen
          ? " 3rem"
          : isSmallScreen
          ? "3rem"
          : "",
      }}
      className="faq  faqsection"
    >
      <header className="section-header mt-5  p-4">
        <h1
          className="mb-4 text-center"
          style={{
            fontSize: is4kScreen
              ? "5.3rem"
              : isXxlScreen
              ? "2.8rem"
              : isXlScreen
              ? "2.6rem"
              : isIpadProPortrait
              ? "3rem"
              : isLargeScreen
              ? "2.5rem"
              : isMediumScreen
              ? "2.5rem"
              : "1.5rem",
          }}
        >
          Read common questions below.
        </h1>
        <h1
          className="text-center"
          style={{
            fontSize: is4kScreen
              ? "2.5rem"
              : isXxlScreen
              ? "1.5rem"
              : isXlScreen
              ? "1.2rem"
              : isIpadProPortrait
              ? "2rem"
              : isLargeScreen
              ? "1.2rem"
              : isMediumScreen
              ? "1.4rem"
              : "1rem",
          }}
        >
          If you still have questions, please{" "}
          <Link to="/contact-us">contact us.</Link>
        </h1>
      </header>
      <div className="container ">
        <div className="row">
          <div className="col-lg-12 pb-4">
            <Accordion>
              {FAQContent.map((item) => {
                const { id, questionName, answerContent } = item;
                return (
                  <Accordion.Item eventKey={id} className="accordion-item">
                    <Accordion.Header
                      className="accordion-header"
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: "row",
                        fontSize: is4kScreen
                          ? "2rem !important"
                          : isLargeScreen
                          ? "1.5rem !important"
                          : "1rem !important",
                        padding: is4kScreen
                          ? "1rem"
                          : // : isLargeScreen
                            // ? ".3rem"
                            "",
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={
                          is4kScreen
                            ? "40"
                            : isXxlScreen
                            ? "20"
                            : isXlScreen
                            ? "20"
                            : isIpadProPortrait
                            ? "30"
                            : isLargeScreen
                            ? "20"
                            : isMediumScreen
                            ? "24"
                            : "20"
                        }
                        height={
                          is4kScreen
                            ? "40"
                            : isXxlScreen
                            ? "20"
                            : isXlScreen
                            ? "20"
                            : isIpadProPortrait
                            ? " 30"
                            : isLargeScreen
                            ? "20"
                            : isMediumScreen
                            ? "24"
                            : "20"
                        }
                        fill="currentColor"
                        className="me-2"
                        viewBox="0 0 16 16"
                        style={{ color: "#57C0D1" }}
                      >
                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                        <path d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z" />
                      </svg>
                      <h3
                        style={{
                          fontSize: is4kScreen
                            ? "2.3rem"
                            : isXxlScreen
                            ? "1.3rem"
                            : isXlScreen
                            ? "1.2rem"
                            : isIpadProPortrait
                            ? "1.7rem"
                            : isLargeScreen
                            ? "1rem"
                            : isMediumScreen
                            ? " 1.2rem"
                            : "0.9rem",
                          margin: "0px",
                        }}
                      >
                        {questionName}
                      </h3>
                    </Accordion.Header>
                    <Accordion.Body>
                      <div
                        style={{
                          fontSize: is4kScreen
                            ? "2.3rem"
                            : isXxlScreen
                            ? "1.2rem"
                            : isXlScreen
                            ? "1.1rem"
                            : isIpadProPortrait
                            ? "1.7rem"
                            : isLargeScreen
                            ? "1rem"
                            : isMediumScreen
                            ? "1.4rem"
                            : "1rem",
                        }}
                        dangerouslySetInnerHTML={{ __html: answerContent }}
                      />
                    </Accordion.Body>
                  </Accordion.Item>
                );
              })}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
}
